import * as React from 'react';
import { compose, withHandlers } from 'recompose';

import { AuthPortal, AuthTokens } from '@topconagriculture/auth';
import { withNavigation, WithNavigationProps } from '@topconagriculture/frontend-utils';
import { graphqlClient } from '@topconagriculture/graphql-client';
import { Router } from '@topconagriculture/react-router';

import { API_CLIENTS } from '../../config/constants';
import { config } from '../../config';
import Api from '../../core/api';
import { authRoutesConfig } from './AuthRoutes';
import withUserProfile, { WithUserProfile } from '../../hocs/withUserProfile';

export interface AuthenticatorPrivateProps extends WithUserProfile, WithNavigationProps {
  onTokenReceived: (tokens: AuthTokens) => void;
}

const Authenticator: React.FunctionComponent<AuthenticatorPrivateProps> = ({ onTokenReceived }) => (
  <AuthPortal
    config={{
      clientId: config.AUTH0_CLIENT_ID,
      domain: config.AUTH0_DOMAIN,
      audience: config.AUTH0_AUDIENCE,
      scope: config.AUTH0_SCOPE,
      redirectUri: config.AUTH0_REDIRECT_URI,
      environment: config.ENVIRONMENT,
    }}
    onTokenReceived={onTokenReceived}
  >
    <Router routes={authRoutesConfig} />
  </AuthPortal>
);

export default compose<AuthenticatorPrivateProps, {}>(
  withUserProfile,
  withNavigation,
  withHandlers({
    onTokenReceived: () => (tokens: AuthTokens) => {
      Api.setAuthToken(tokens);
      graphqlClient.setTokens(config.TENANT_ID, [{ name: API_CLIENTS.graphqlClient, tokens: tokens }]);
    },
  }),
)(Authenticator);
